// Polyfills
import "babel-polyfill";
import { polyfillsReady } from './lib/Polyfills';

//Async/await and regenerator currently throw lots of bluebird warnings, so disable them
if (typeof Promise !== 'undefined' && typeof Promise.config === 'function') {
    Promise.config({
        warnings: false
    });
}

import React from 'react';
import ReactDOM from 'react-dom';

import config from './config';
import appVersion from './appVersion';
import Assets from './helpers/Assets';
import ModalActions from './actions/ModalActions';
import AppActions from './actions/AppActions';
import { PersistedStores } from './stores/BaseStore';
import AppDispatcher, { logActionHandler } from './dispatcher/AppDispatcher';

/* eslint-disable no-console */

export default function createApp(onInit, onRender) {
    return {
        info () {
            console.log(
                `OTRL
                ====
                App: ${config.get('name')}
                Version: ${appVersion.version}
                Assets: ${Assets.assetVersion}
                Environment: ${config.get('environment')}
                Brand: ${config.get('brand')}`
                .replace(/^\s*/mg, '')
            );

            transformReactErrorsToWarnings();
        },

        initDebug () {
            if (config.get('debug')) {
                AppDispatcher.register(logActionHandler);
                if (config.get('a11y')) {
                    var a11y = require('react-a11y').default;
                    a11y(React, ReactDOM);
                }
            }
        },

        init (appConfig, version, assetVersion) {
            polyfillsReady().then(() => {
                config.init(appConfig);
                appVersion.version = version;
                Assets.assetVersion = assetVersion;

                onInit();

                this.info();
                this.initDebug();
                AppActions.initialize();
                PersistedStores.map(store => store.loadPersistedState());
                const containerEl = document.getElementById('container');
                onRender(containerEl);
            });
        },

        /**
         * Expose some functions for the app to use
         */
        appActions: {
            openModal (type, props) {
                ModalActions.open(type.toUpperCase(), props);
            },

            closeModal () {
                ModalActions.close();
            },

            toggleFeature (featureName, value) {
                AppActions.toggleFeature(featureName, value);
            },

            listFeatures () {
                const FeatureFlagStore = require('./stores/FeatureFlagStore').default;
                const features = config.keys().filter((key) => key.match(/^(?:enable|disable)/));
                const table = features.reduce(
                    (flags, name) => {
                        flags[name] = { value: FeatureFlagStore.get(name) };
                        return flags;
                    }, {});
                console.table(table);
            },

            setFeatureVariant (feature, variant) {
                AppActions.setFeatureVariant(feature, variant);
            },

            listFeatureVariants () {
                const FeatureVariantStore = require('./stores/FeatureVariantStore').default;
                console.table(FeatureVariantStore.getAll());
            },

            enableTracking () {
                AppActions.enableTracking();
            },

            disableTracking () {
                AppActions.disableTracking();
            }
        }
    };
}

const transformReactErrorsToWarnings = () => {
    const matchedMessages = ['Warning:'];
    const oldConsoleError = console.error;

    console.error = (...args) => {
        let consoleFunction = oldConsoleError;

        if (
            typeof args[0] === 'string' &&
            matchedMessages.some(error => args[0].startsWith(error))
        ) {
            consoleFunction = console.warn;
        }

        consoleFunction(...args);
    };
};

/* eslint-enable no-console */
